import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Col, Row, Card, Form, Button, InputGroup, Nav } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { useCookies } from 'react-cookie';
import { getTabStatistic } from '../../../../controller/api/__loto__/cart'
import { Context } from '../Cart'

const GAME_OPTIONS = [
  { value: '', label: 'Tất cả trò chơi' },
  { value: 'loto', label: 'Lô tô truyền thống' },
  // { value: 'loto-thudo', label: 'Lô tô điện toán Miền Bắc' },
]

const _FilterForm = () => {

  const { state, dispatch } = useContext(Context);
  const [cookies] = useCookies(['lottmekong'])

  const [from, setFrom] = useState(state.filter.from)
  const [to, setTo] = useState(state.filter.to)
  const [phone, setPhone] = useState(state.filter.phone)
  const [name, setName] = useState(state.filter.name)
  const [cartId, setCartId] = useState(state.filter.cartId)
  const [region, setRegion] = useState(state.filter.region)
  const [gameId, setGameId] = useState(state.filter.gameId)

  const isNewTab = state.activeTab === 'new'
  const isWaitingResultTab = state.activeTab === 'waiting_result'
  const isHasResultTab = state.activeTab === 'has_result'
  const showDateFilters = !isNewTab
  const [tabStatistic, setTabStatistic] = useState({
    all: 0,
    new: 0,
    waitingResult: 0,
    hasResult: 0,
  })

  useEffect(() => {
    setFrom(state.filter.from)
    setTo(state.filter.to)
    setPhone(state.filter.phone)
    setName(state.filter.name)
    setCartId(state.filter.cartId)
    setRegion(state.filter.region)
    setGameId(state.filter.gameId)
  }, [state.filter])

  useEffect(() => {
    const fetchTabStatistic = async () => {
      const query = {
        phone: state.filter.phone || undefined,
        name: state.filter.name || undefined,
        cartId: state.filter.cartId || undefined,
        region: state.filter.region || undefined,
        gameId: state.filter.gameId || undefined,
        from: state.filter.from,
        to: state.filter.to,
      }

      const response = await getTabStatistic(cookies.lottmekong, query)

      if (response) {
        setTabStatistic({
          all: response.all || 0,
          new: response.new || 0,
          waitingResult: response.waitingResult || 0,
          hasResult: response.hasResult || 0,
        })
      }
    }

    fetchTabStatistic()
  }, [cookies.lottmekong, state.filter.from, state.filter.to, state.filter.phone, state.filter.name, state.filter.cartId, state.filter.region, state.filter.gameId, state.filterPressCount])

  const _submitForm = useCallback(() => {
    dispatch({
      type: 'SUBMIT_FILTER',
      payload: {
        from,
        to,
        phone,
        name,
        cartId,
        region,
        gameId,
      }
    })
  }, [dispatch, from, to, phone, name, cartId, region, gameId])

  const _exportForm = () => {
    dispatch({
      type: 'EXPORT_DATA'
    })
  }

  const _handleChangeTab = useCallback((tab) => {
    dispatch({
      type: 'SET_ACTIVE_TAB',
      payload: tab
    })
  }, [dispatch])

  const renderFilterField = (label, control) => (
    <Col sm={12} md={6}>
      <Row className="align-items-center">
        <Col md={3} className='text-left align-self-center'>
          <Form.Label className="mb-md-0">{label}</Form.Label>
        </Col>
        <Col md={9}>
          {control}
        </Col>
      </Row>
    </Col>
  )

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <Nav
            variant="tabs"
            activeKey={state.activeTab}
            className="border-0 mb-3"
            onSelect={(key) => key && _handleChangeTab(key)}
          >
            <Nav.Item>
              <Nav.Link eventKey="all">Tất cả đơn ({tabStatistic.all})</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="new">Đơn mới ({tabStatistic.new})</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="waiting_result">Chờ KQ ({tabStatistic.waitingResult})</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="has_result">Có kết quả ({tabStatistic.hasResult})</Nav.Link>
            </Nav.Item>
          </Nav>
          <Row className="align-items-center">
            <Col className='align-self-center'>
              <h5>
                {isNewTab
                  ? 'Đơn mới cần xử lý'
                  : isWaitingResultTab
                    ? 'Đơn chờ kết quả'
                    : isHasResultTab
                      ? 'Đơn có kết quả'
                      : 'Tất cả đơn hàng'}
              </h5>
            </Col>
            <Col className='text-right'>
              <Button style={{ marginRight: 20 }} variant="info" type="submit" onClick={_submitForm}>Tìm kiếm</Button>
              <Button style={{ marginRight: 20 }} variant="success" type="button" onClick={_exportForm}>Xuất file</Button>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <div>
              <Row className='gy-3 p-1'>
                {renderFilterField(
                  'Trò chơi',
                  <Form.Select value={gameId} onChange={(e) => setGameId(e.target.value)}>
                    {GAME_OPTIONS.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </Form.Select>
                )}
                {renderFilterField(
                  'Vùng',
                  <Form.Select value={region} onChange={(e) => setRegion(e.target.value)}>
                    <option value="">Tất cả vùng</option>
                    <option value="MB">Miền Bắc</option>
                    <option value="MT">Miền Trung</option>
                    <option value="MN">Miền Nam</option>
                  </Form.Select>
                )}
                {renderFilterField(
                  'Số điện thoại',
                  <Form.Control
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    type="text"
                    placeholder="Nhập số điện thoại"
                  />
                )}
                {renderFilterField(
                  'Tên KH',
                  <Form.Control
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    type="text"
                    placeholder="Nhập tên khách hàng"
                  />
                )}
                {renderFilterField(
                  'Mã đơn',
                  <Form.Control
                    value={cartId}
                    onChange={(e) => setCartId(e.target.value)}
                    type="text"
                    placeholder="Nhập mã đơn hàng"
                  />
                )}
              </Row>
              {showDateFilters && (
                <Row className='gy-3 p-1'>
                  {renderFilterField(
                    'Từ ngày',
                    <Datetime
                      dateFormat="DD/MM/YYYY"
                      timeFormat={false}
                      onChange={setFrom}
                      renderInput={(props, openCalendar) => (
                        <InputGroup>
                          <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                          <Form.Control
                            required
                            type="text"
                            value={from ? moment(from).format("DD/MM/YYYY") : ""}
                            placeholder="dd/mm/yyyy"
                            onFocus={openCalendar}
                            onChange={() => { }} />
                        </InputGroup>
                      )}
                    />
                  )}
                  {renderFilterField(
                    'Đến ngày',
                    <Datetime
                      dateFormat="DD/MM/YYYY"
                      timeFormat={false}
                      onChange={setTo}
                      renderInput={(props, openCalendar) => (
                        <InputGroup>
                          <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                          <Form.Control
                            required
                            type="text"
                            value={to ? moment(to).format("DD/MM/YYYY") : ""}
                            placeholder="dd/mm/yyyy"
                            onFocus={openCalendar}
                            onChange={() => { }} />
                        </InputGroup>
                      )}
                    />
                  )}
                </Row>
              )}
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default React.memo(_FilterForm)
